<template>
  <el-container class="add-dialog">
    <header>
      <span>开户</span>
      <i class="iconfont icon-close" @click="dialogClose"></i>
    </header>
    <div class="content">
      <div class="banner">
        <div class="h1">开户</div>
        <div class="h2">精准把握每一个客户资源</div>
      </div>
      <div class="form">
        <div class="form-header">基本信息</div>
        <div class="form-content">
          <div class="form-item single">
            <span class="item-title"><span class="need">*</span>客户名称</span>
            <div class="item-right">
              <el-input v-model="companyName" placeholder="请输入(必填)" size="medium" maxlength="25" :readonly="addType == 3"></el-input>
            </div>
            <div class="err" v-if="err_cn"><i class="el-icon-warning"></i>{{err_cn}}</div>
          </div>
          <div class="form-item">
            <span class="item-title"><span class="need">*</span>客户姓名</span>
            <div class="item-right">
              <el-input v-model="userName" placeholder="请输入内容" size="medium" :readonly="addType == 3"></el-input>
            </div>
            <div class="err" v-if="err_un"><i class="el-icon-warning"></i>{{err_un}}</div>
          </div>
          <div class="form-item">
            <span class="item-title"><span class="need">*</span>联系电话</span>
            <div class="item-right">
              <el-input v-model="phone" placeholder="请输入(必填)" size="medium" :readonly="addType == 3" class="country-phone">
                <el-select v-model="countryValue" slot="prepend" placeholder="请选择" :disabled="addType == 3" popper-class="select-search-dropdowm-tx phone-search-dropdowm-tx">
                  <div class="search-box">
                    <el-input placeholder="请输入" v-model="keyword1" class='search-text' clearable size="medium" @blur="keyword1 = keyword1.trim()">
                      <i slot='prefix' class='el-input__icon el-icon-search'></i>
                    </el-input>
                  </div>
                  <template v-for="v in countryData">
                    <el-option :key="v.id" :label="'+'+v.value" :value="v.id" v-if="v.value.includes(keyword1.trim()) || v.label.includes(keyword1.trim())">
                      {{v.label}}
                      <span class="right">(+{{v.value}})</span>
                    </el-option>
                  </template>
                </el-select>
              </el-input>
            </div>
            <div class="err" v-if="err_p"><i class="el-icon-warning"></i>{{err_p}}</div>
          </div>
          <div class="form-item" v-if="addType == 1 || addType == 4">
            <span class="item-title"><span class="need">*</span>登录密码</span>
            <div class="item-right">
              <el-input v-model="password" placeholder="请输入(必填)" size="medium"></el-input>
            </div>
            <div class="err" v-if="err_pwd"><i class="el-icon-warning"></i>{{err_pwd}}</div>
          </div>
          <div class="form-item">
            <span class="item-title"><span class="need">*</span>部署方式</span>
            <div class="item-right">
              <el-select v-model="deployment_type" placeholder="请选择(必填)" :disabled="true" size="medium">
                <el-option v-for="item in configuration" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="err" v-if="err_dt"><i class="el-icon-warning"></i>{{err_dt}}</div>
          </div>
          <div class="form-item" v-if="deployment_type === 1">
            <span class="item-title"><span class="need">*</span>域名地址</span>
            <div class="item-right">
              <el-input v-model="domain_address" placeholder="请输入" size="medium"></el-input>
            </div>
            <div class="err" v-if="err_da"><i class="el-icon-warning"></i>{{err_da}}</div>
          </div>
          <!-- <div class="form-item" v-if="deployment_type === 1">
            <span class="item-title"><span class="need"></span>数据库地址</span>
            <div class="item-right">
              <el-input v-model="database_url" placeholder="请输入" size="medium"></el-input>
            </div>
          </div>
          <div class="form-item" v-if="deployment_type === 1">
            <span class="item-title"><span></span></span>
            <span class="item-title item-title2"><span>数据</span><span>库用户名</span></span>
            <div class="item-right">
              <el-input v-model="database_username" placeholder="请输入" size="medium"></el-input>
            </div>
          </div>
          <div class="form-item" v-if="deployment_type === 1">
            <span class="item-title">数据库密码</span>
            <div class="item-right">
              <el-input v-model="database_passwd" placeholder="请输入" size="medium"></el-input>
            </div>
          </div> -->
          <div class="form-item single50">
            <span class="item-title"><span class="need">*</span>开通版本</span>
            <div class="item-right">
              <el-select v-model="version" placeholder="请选择(必填)" size="medium">
                <el-option v-for="item in vOptions" :key="item.id" :label="item.version_name" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="err" v-if="err_v"><i class="el-icon-warning"></i>{{err_v}}</div>
          </div>
          <div class="form-item">
            <span class="item-title"><span class="need">*</span>组件版本</span>
            <div class="item-right">
              <el-select v-model="field_typesId" placeholder="请选择(必填)" size="medium">
                <el-option v-for="item in componentData" :key="item.id" :label="item.cm_name" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="err" v-if="err_ft"><i class="el-icon-warning"></i>{{err_ft}}</div>
          </div>
          <div class="form-item single50">
            <span class="item-title"><span class="need">*</span>开通坐席</span>
            <div class="item-right">
              <el-input v-model="peopleNumber" placeholder="请输入(必填)" size="medium" type="number" suffix-icon="iconfont icon-shuzi1"></el-input>
            </div>
            <div class="err" v-if="err_pn"><i class="el-icon-warning"></i>{{err_pn}}</div>
          </div>
          <div class="form-item">
            <span class="item-title item-title2"><span><span class="need">*</span>套餐</span><span>开始日期</span></span>
            <div class="item-right">
              <el-date-picker v-model="startDate" type="date" placeholder="选择日期" value-format="timestamp" size="medium" :readonly="addType == 5"></el-date-picker>
            </div>
            <div class="err" v-if="err_sd"><i class="el-icon-warning"></i>{{err_sd}}</div>
          </div>
          <div class="form-item">
            <span class="item-title item-title2"><span><span class="need">*</span>套餐</span><span>结束日期</span></span>
            <div class="item-right">
              <el-date-picker v-model="endDate" type="date" placeholder="选择日期" value-format="timestamp" size="medium" :readonly="addType == 5"></el-date-picker>
            </div>
            <div class="err" v-if="err_ed"><i class="el-icon-warning"></i>{{err_ed}}</div>
          </div>
          <div class="form-item" v-if="deployment_type === 0">
            <span class="item-title"><span class="need">*</span>附件空间</span>
            <div class="item-right">
              <el-input v-model="attachment" placeholder="请输入(必填)" size="medium" class="gb" type="number">
              </el-input>
            </div>
            <div class="err" v-if="err_a"><i class="el-icon-warning"></i>{{err_a}}</div>
          </div>
          <div class="form-item" v-if="deployment_type === 0">
            <span class="item-title"><span class="need">*</span>总数据量</span>
            <div class="item-right">
              <el-input v-model="dataSize" placeholder="请输入(必填)" size="medium" class="tiao" type="number">
              </el-input>
            </div>
            <div class="err" v-if="err_ds"><i class="el-icon-warning"></i>{{err_ds}}</div>
          </div>
          <div class="form-item" v-if="addType==3||addType==4||addType==5">
            <span class="item-title item-title2"><span><span class="need">*</span>新增坐席</span><span>单价(个)</span></span>
            <div class="item-right">
              <el-input v-model="seat_unit_price" type="number" placeholder="请输入" size="medium" :class="{'yuan': deployment_type==1, 'yuan2': deployment_type==0}"></el-input>
            </div>
            <div class="err" v-if="err_up"><i class="el-icon-warning"></i>{{err_up}}</div>
          </div>
          <div class="form-item">
            <span class="item-title">内部帐户</span>
            <div class="item-right">
              <el-radio-group v-model="internal_account">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="form-item" :class="{'single50': addType==0||addType==1||addType==2}">
            <span class="item-title">邀请码</span>
            <div class="item-right">
              <el-input v-model="inviteCode" placeholder="请输入" size="medium" readonly></el-input>
            </div>
          </div>
          <div class="form-item single">
            <span class="item-title">维护客服</span>
            <div class="item-right">
              <el-select v-model="maintain" placeholder="请选择">
                <el-option v-for="item in userList" :key="item.id" :label="item.user_name" :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-item single">
            <span class="item-title">备注</span>
            <div class="item-right">
              <el-input type="textarea" v-model="remark" placeholder="请输入" size="medium" :rows="3" resize="none" :maxlength="500"></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSave">保 存</el-button>
    </footer>
  </el-container>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import {regular, TFParameter, country} from '@/common/js/constant.js'
import mixin from '@/common/js/mixins.js'
import tool from '@/common/js/tool.js'
export default {
  props: ['customer'],
  name: 'customerAdd',
  data () {
    return {
      response: this.customer,
      addType: '',
      companyName: '',
      userName: '',
      phone: '',
      password: '',
      version: 1,
      peopleNumber: '1',
      startDate: new Date().getTime(),
      endDate: new Date().getTime(),
      attachment: '2',
      dataSize: '3',
      inviteCode: '',
      maintain: '',
      remark: '',
      field_typesId: '',
      componentData: [],
      deployment_type: 0,
      database_url: '',
      database_username: '',
      database_passwd: '',
      domain_address: '',
      err_cn: '',
      err_un: '',
      err_p: '',
      err_pwd: '',
      err_v: '',
      err_ft: '',
      err_pn: '',
      err_sd: '',
      err_ed: '',
      err_a: '',
      err_ds: '',
      err_dt: '',
      err_da: '',
      seat_unit_price: '',
      err_up: '',
      userList: [],
      configuration: [{'label': '云服务初始化', 'id': 0}, {'label': '本地初始化', 'id': 1}],
      countryData: country,
      countryValue: '86',
      keyword1: '',
      internal_account: 1
    }
  },
  mixins: [mixin],
  mounted () {
    this.queryUserList()
    this.queryAllChargingStrategy()
    var date = new Date()
    var form = this.customer
    console.log(form)
    /**
     * addType - 0: 审批  1：试用新增  2：试用编辑  3：转为正式  4：正式新增  5：正式编辑
     */
    this.addType = form.addType
    this.companyName = form.company_name
    this.userName = form.user_name
    this.phone = ''
    if (form.phone) {
      var json = tool.phoneParsing(form.phone)
      this.phone = json.phone
      this.countryValue = json.prefix || '86'
    }
    this.domain_address = form.local_domain_address
    this.version = form.edition ? parseInt(form.edition) : undefined
    this.peopleNumber = form.allow_number
    this.startDate = form.start_time
    this.endDate = form.end_time
    this.attachment = form.attachment_size
    this.dataSize = form.data_size
    this.inviteCode = form.invite_code
    this.maintain = form.customer_id
    this.remark = form.remark
    this.password = form.login_pwd
    this.seat_unit_price = form.seat_unit_price
    this.internal_account = form.internal_account ? parseInt(form.internal_account) : 1

    this.deployment_type = parseInt(form.deployment_type || 0)
    // this.database_url = form.database_url
    // this.database_username = form.database_username
    // this.database_passwd = form.database_passwd
    if (this.addType === 1 || this.addType === 4) {
      this.startDate = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 00:00:00').getTime()
      this.endDate = new Date((date.getFullYear() + 1) + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 23:59:59').getTime()
    }
    this.getEnableComponentManageList(form.cm_id)
  },
  methods: {
    dialogSave () {
      var b = this.dataTraversal()
      console.log('提交...', b, this)
      if (b) {
        let fieldTypes = ''
        let cmName = ''
        let contains = tool.contains(this.componentData, 'id', this.field_typesId)
        if (contains) {
          fieldTypes = contains.field_types
          cmName = contains.cm_name
        }
        let p = tool.phoneVerify(this.countryValue, this.phone, this.countryData)
        let pwd = this.customer.user_pwd
        if (this.addType === 1 || this.addType === 4) {
          pwd = tool.encrypt(this.password + TFParameter.TEAMFACEPWD)
        }
        var jsondata = {
          'id': this.customer.id,
          'company_name': this.companyName,
          'user_name': this.userName,
          'field_types': fieldTypes, // 组件版本
          'deployment_type': this.deployment_type, // 部署方式
          'local_domain_address': this.domain_address,
          'cm_id': this.field_typesId, // 组件版本
          'phone': p.phone,
          'edition': this.version, // 开通版本
          'allow_number': this.peopleNumber, // 开通坐席
          'start_time': this.startDate,
          'end_time': this.endDate,
          'attachment_size': this.attachment, // 附件空间
          'data_size': this.dataSize, // 总数据量
          'invite_code': this.inviteCode,
          'user_id': this.maintain,
          'remark': this.remark,
          'seat_unit_price': this.seat_unit_price,
          'login_pwd': pwd,
          'internal_account': this.internal_account // 内部帐户
        }
        jsondata.end_time = (new Date((new Date(this.endDate)).toLocaleDateString())).getTime() + 24 * 60 * 60 * 1000 - 1
        if (this.addType === 2 || this.addType === 5) jsondata.cm_name = cmName
        console.log(jsondata)
        this.$bus.emit('saveAddModal', jsondata, this.addType)
      }
    },
    /** 获取列表 */
    queryUserList () {
      var jsondata = {'pageNum': 1, 'pageSize': 9999}
      HTTPServer.queryUserList(jsondata, 'Loading').then((res) => {
        this.userList = res.dataList
      })
    },
    /** 获取 组件管理 */
    getEnableComponentManageList (id) {
      console.log(22222, id)
      HTTPServer.getEnableComponentManageList({}, 'Loading').then((res) => {
        this.componentData = res
        let firstId = ''
        res.map((item) => {
          if (!firstId) firstId = item.id
          if (item.id === id) {
            this.field_typesId = item.id
          }
        })
        // 审批客户时选择默认组件
        if (firstId && this.customer.addType === 0) {
          this.field_typesId = id
        }
      })
    },
    /** 数据遍历 */
    dataTraversal () {
      this.err_cn = ''
      this.err_un = ''
      this.err_p = ''
      this.err_pwd = ''
      this.err_v = ''
      this.err_ft = ''
      this.err_pn = ''
      this.err_sd = ''
      this.err_ed = ''
      this.err_a = ''
      this.err_ds = ''
      this.err_da = ''
      this.err_up = ''
      let reg = /^[1-9]\d*$/
      if (!this.companyName) {
        this.err_cn = '公司名称不能为空'
        return false
      }
      if (!this.userName) {
        this.err_un = '客户姓名不能为空'
        return false
      }
      let p = tool.phoneVerify(this.countryValue, this.phone, this.countryData)
      console.log(p)
      if (p.error) {
        this.err_p = p.error
        return false
      }
      // if (!this.phone) {
      //   this.err_p = '联系电话不能为空'
      //   return false
      // }
      // if (!regular.phone.test(this.phone)) {
      //   this.err_p = '联系电话格式不正确'
      //   return false
      // }
      if (this.addType === 1 || this.addType === 4) {
        if (!this.password) {
          this.err_pwd = '密码不能为空'
          return false
        }
        if (!regular.pwdRegx.test(this.password)) {
          this.err_pwd = '密码格式错误'
          return false
        }
      }
      if (this.deployment_type === 1 && !this.domain_address) {
        this.err_da = '域名地址不能为空'
        return
      }
      if (this.deployment_type === 1 && (!(regular.pattIp.test(this.domain_address) || regular.ipRegularJUdge.test(this.domain_address) || regular.domain2.test(this.domain_address)))) {
        this.err_da = '域名地址格式错误'
        return
      }
      if (!this.version) {
        this.err_v = '开通版本不能为空'
        return false
      }
      if (!this.field_typesId) {
        this.err_ft = '组件版本不能为空'
        return false
      }
      if (!this.peopleNumber) {
        this.err_pn = '开通坐席不能为空'
        return false
      }
      if (!reg.test(this.peopleNumber)) {
        this.err_pn = '开通坐席只能为正整数'
        return false
      }
      if (!this.startDate) {
        this.err_sd = '套餐开始日期不能为空'
        return false
      }
      if (!this.endDate) {
        this.err_ed = '套餐结束日期不能为空'
        return false
      }
      if (this.startDate > this.endDate) {
        this.err_ed = '套餐结束日期不能小于或等于开始时间'
        return false
      }
      if (this.deployment_type === 0 && !this.attachment) {
        this.err_a = '附件空间不能为空'
        return false
      }
      if (this.deployment_type === 0 && !reg.test(this.attachment)) {
        this.err_a = '附件空间只能为正整数'
        return false
      }
      if (this.deployment_type === 0 && !this.dataSize) {
        this.err_ds = '总数据量不能为空'
        return false
      }
      if (this.addType === 3 || this.addType === 4 || this.addType === 5) {
        if (!this.seat_unit_price) {
          this.err_up = '新增坐席单价不能为空'
          return false
        }
        if (!regular.decimal2.test(this.seat_unit_price)) {
          this.err_up = '新增坐席单价格式不正确'
          return false
        }
      }
      return true
    },
    dialogClose () {
      this.$bus.emit('closeAddModal', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/customer-add.vue